import { Injectable } from "@angular/core";
@Injectable()
export class Datatransfer {
  apiName: string;
  areaName: string;
  label: string;
  currentrow: any;
}
export class VoucherKindInfo {
  VoucherKindId: number;
}
